/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PurchaseOrderEmittedItemsApiModel } from './purchase-order-emitted-items';

export interface PurchaseOrderApiModel {
  /**
   * Email for error notification
   */
  admin_email?: string;
  /**
   * Available items count for emission  (Only for Response data)
   */
  available_items?: number;
  /**
   * Business ID
   */
  business_id: string;
  /**
   * URL for payment system callback (Only for Response data on create request)
   */
  callback_url?: string;
  /**
   * Comment
   */
  comment?: string;
  /**
   * Created order time
   */
  created?: string;
  /**
   * Сurrency code
   */
  currency: string;
  /**
   * Customer Email
   */
  email?: string;
  /**
   * Emitted items (Only for Response data)
   */
  emitted_items?: Array<PurchaseOrderEmittedItemsApiModel>;
  /**
   * Order ID
   */
  id?: string;
  /**
   * Ordered item amount
   */
  item_amount: number;
  /**
   * Ordered item external code
   */
  item_code?: string;
  /**
   * Ordered item ID
   */
  item_id: string;
  /**
   * Ordered item price
   */
  item_price: number;
  /**
   * Ordered item quantity
   */
  item_quantity: number;
  /**
   * Ordered item type
   */
  item_type: PurchaseOrderApiModelItemTypeEnum;
  /**
   * Notification language
   */
  language?: string;
  /**
   * Notify customer
   */
  notify: number;
  /**
   * Payment type
   */
  payment_type: PurchaseOrderApiModelPaymentTypeEnum;
  /**
   * Customer phone
   */
  phone?: string;
  /**
   * Payment processed time
   */
  processed?: string;
  /**
   * Referral code
   */
  referral_code?: string;
  /**
   * Notification sent time
   */
  sent?: string;
  /**
   * Order status
   */
  status?: PurchaseOrderApiModelStatusEnum;
  /**
   * Add emitted items to the customer wallet
   */
  wallet?: number;
}
export enum PurchaseOrderApiModelItemTypeEnum {
  Coupon = 'coupon',
  PrepaidCard = 'prepaid-card'
}
export enum PurchaseOrderApiModelPaymentTypeEnum {
  Wayforpay = 'wayforpay'
}
export enum PurchaseOrderApiModelStatusEnum {
  Created = 'created',
  Completed = 'completed',
  Canceled = 'canceled',
  Failed = 'failed'
}
